import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Crosshair } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const pin = L.divIcon({ className: "", html: '<div style="width:18px;height:18px;border-radius:50%;background:#10b981;border:3px solid #fff;box-shadow:0 0 0 2px #10b981"></div>', iconSize: [18, 18], iconAnchor: [9, 9] });
const DEFAULT = [-6.2, 106.816];

export const getGps = () => new Promise((resolve, reject) => {
  const g = window.__gps;
  if (g) { resolve({ lat: g.lat, lng: g.lng }); return; }
  if (!navigator.geolocation) { reject(new Error("GPS tidak tersedia")); return; }
  navigator.geolocation.getCurrentPosition((p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
    () => navigator.geolocation.getCurrentPosition((p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }), reject, { enableHighAccuracy: false, maximumAge: 60000, timeout: 15000 }),
    { enableHighAccuracy: true, timeout: 8000 });
});

export const MemberMap = ({ lat, lng, onChange, height = 220, testId = "member-map" }) => {
  const el = useRef(null);
  const map = useRef(null);
  const marker = useRef(null);
  useEffect(() => {
    map.current = L.map(el.current, { zoomControl: true }).setView(lat != null ? [lat, lng] : DEFAULT, lat != null ? 16 : 11);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: "© OpenStreetMap" }).addTo(map.current);
    if (onChange) map.current.on("click", (e) => onChange({ lat: e.latlng.lat, lng: e.latlng.lng }));
    return () => { map.current.remove(); map.current = null; marker.current = null; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!map.current || lat == null) return;
    if (!marker.current) marker.current = L.marker([lat, lng], { icon: pin }).addTo(map.current);
    else marker.current.setLatLng([lat, lng]);
    map.current.setView([lat, lng], Math.max(map.current.getZoom(), 16));
  }, [lat, lng]);
  return <div ref={el} style={{ height }} className="w-full rounded-2xl overflow-hidden border z-0" data-testid={testId} />;
};

export const CoordinatePicker = ({ lat, lng, onChange }) => {
  const [busy, setBusy] = useState(false);
  const locate = async () => {
    setBusy(true);
    try { onChange(await getGps()); } catch { toast.error("Aktifkan GPS dan izinkan akses lokasi"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" className="h-10 rounded-full" onClick={locate} disabled={busy} data-testid="member-gps-button"><Crosshair className="h-4 w-4 mr-2" />{busy ? "Mencari lokasi..." : "Ambil Lokasi GPS"}</Button>
        <span className="text-xs font-mono text-muted-foreground" data-testid="member-coordinates">{lat != null ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : "Belum ada titik"}</span>
      </div>
      <MemberMap lat={lat} lng={lng} onChange={onChange} height={200} testId="member-form-map" />
      <p className="text-xs text-muted-foreground">Ketuk peta untuk menggeser titik.</p>
    </div>
  );
};
